import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ko from "./locales/ko.json";
import en from "./locales/en.json";
import fil from "./locales/fil.json";

// 기본 로케일: 한국어 (최초 접속 시). 저장된 선택(lang)이 있으면 그대로 유지.
const savedLang = localStorage.getItem("lang") || "ko";

i18n.use(initReactI18next).init({
  resources: {
    ko: { translation: ko },
    en: { translation: en },
    fil: { translation: fil },
  },
  lng: savedLang,
  fallbackLng: "en",
  keySeparator: false,
  interpolation: { escapeValue: false },
});

export const languages = [
  { key: "ko", label: "한국어", flag: "🇰🇷" },
  { key: "en", label: "English", flag: "🇺🇸" },
  { key: "fil", label: "Filipino", flag: "🇵🇭" },
];

export default i18n;
